(function(){
  'use strict';

  window.Coop = window.Coop || { Modules: {} };

  var selector = '[data-autocomplete-address]';

  var AutoComplete = function($el) {
    this.init($el);
    return this;
  };

  Coop.Modules.AutoComplete = {
    init: function() {
      return $(selector).each(function() {
        $(this).data('AutoComplete', new AutoComplete($(this)));
      });
    }
  };

  AutoComplete.prototype = {
    defaults: {
      minChars: 3,
      typeDelay: 350,
      showPrivateStores: true,
      containerClass: 'autocomplete-container',
      predictionsContainer: null,
      locationAPI: window.LOCATION_API,
      locationAPIParams: {
        format: 'json',
        private: true
      },
      placesAPI: window.AUTOCOMPLETE_API
    },
    keys: {
      UP: 38,
      DOWN: 40,
      LEFT: 37,
      RIGHT: 39,
      ESC: 27,
      ENTER: 13,
      TAB: 9,
      BACKSPACE: 8,
      SHIFT: 16
    },
    init: function($el) {
      this.$suggestionInput = $el;
      this.randomId = Math.random().toString(36).substr(2, 8);
      this.$predictionsContainer = null;

      this.resultsType = this.$suggestionInput.data('autocompleteAddress') || 'stores';

      this.minChars = this.defaults.minChars;
      this.predictions = [];
      this.$listItems = [];
      this.selectedIndex = -1;
      this.lastSearch = null;

      this.globalTimeout = null;

      this.$suggestionInput.attr('autocomplete', 'off');

      this.createAutoCompleteContainer();
    },
    bindAutoCompleteEvents: function() {
      var self = this;

      this.bindStatusEvents();

      this.$suggestionInput
        .off('focus.autoComplete')
        .on('focus.autoComplete', function(ev) {
          self.onFocus(ev);
        });

      this.$suggestionInput
        .off('blur.autoComplete')
        .on('blur.autoComplete', function(ev) {
          self.onBlur(ev);
        })
        .on('focusout.autoComplete', function(ev){
          self.onFocusOut(ev);
        });

      // autocomplete input keypress events
      this.$suggestionInput
        .off('keydown.autoComplete')
        .on('keydown.autoComplete', this.$suggestionInput, function(ev) {
          self.onKeyPress(ev);
        });

      this.$suggestionInput
        .off('keyup.autoComplete')
        .on('keyup.autoComplete', function(ev) {
          self.onKeyUp(ev);
        });

      this.$suggestionInput
        .off('change.autoComplete')
        .on('change.autoComplete', function(ev) {
          if (self.query().length === 0) {
            self.removePredictions();
          }
        });
    },
    bindListEvents: function(){
      var self = this;

      $('.autocomplete-item')
          .on('mouseover.autoComplete', function (ev) {
            var index = $(this).data('index');
            self.updateSelected(index);
          })
          .on('mousedown.autoComplete click.autoComplete', function(ev) {
            var index = $(this).data('index');
            self.updateSelected(index);
            self.useSelected();
          });
    },
    bindStatusEvents: function() {
      this.$suggestionInput
        .off('startLookup')
        .on('startLookup', function(){
          $('.store-lookup-input .icon.icon-cancel').removeClass('icon-cancel').addClass('btn-loading');
        });

      this.$suggestionInput
        .off('stopLookup')
        .on('stopLookup', function(){
          $('.store-lookup-input .icon').removeClass('btn-loading').addClass('icon-cancel');
        });
    },
    query: function() {
      return this.$suggestionInput.val().trim();
    },
    onFocus: function() {
      if (this.$predictionsContainer.find('.autocomplete-item').length) {
        this.$predictionsContainer.show();
      }
    },
    onFocusOut: function(event) {
      var buttonClicked = false;
      var clickableButtons = ['btn-reset', 'btn-finder-submit'];
      var relatedTarget = event.relatedTarget;

      if ( relatedTarget ){
        for ( var i = 0; i < clickableButtons.length; i ++ ) {
          var className = clickableButtons[i];
          if (!buttonClicked) {
            buttonClicked = relatedTarget.classList.contains(className);
          }
        }
      }

      var hasResults = $('.finder-results-list').find('ul').length > 0;

      if ( !buttonClicked && !hasResults ) {
        this.$suggestionInput.val('').focus().trigger('change');
      }
    },
    onBlur: function() {
      this.$predictionsContainer.hide();
    },
    onKeyPress: function (e) {
      switch (e.which) {
        case this.keys.ESC:
          this.selectedIndex = -1;
          this.removePredictions();
          this.$suggestionInput.val('');
          break;
        case this.keys.ENTER:
          if (this.selectedIndex === -1) {
            clearTimeout(this.globalTimeout);
            this.removePredictions();
            return;
          }
          this.useSelected();
          break;
        case this.keys.UP:
          this.move('up');
          break;
        case this.keys.DOWN:
          this.move('down');
          break;
        default:
          return;
      }

      e.stopImmediatePropagation();
      e.preventDefault();
    },
    onKeyUp: function(e) {
      var self = this;

      switch (e.which) {
        case this.keys.UP:
        case this.keys.DOWN:
        case this.keys.TAB:
        case this.keys.RIGHT:
        case this.keys.LEFT:
        case this.keys.SHIFT:
        case this.keys.ENTER:
          return false;
      }

      if (this.query().length < this.minChars) {
        clearTimeout(this.globalTimeout);
        this.removePredictions();
      }

      if (this.query().length >= this.minChars) {
        clearTimeout(this.globalTimeout);
        this.globalTimeout = setTimeout(function() {
          self.handleSuggestionChange();
        }, this.defaults.typeDelay);
      }
    },
    updateSelected: function(index) {
      this.selectedIndex = index;

      $('li', this.$predictionsContainer).removeClass('selected')
        .eq(index)
        .addClass('selected');
    },
    adjustListScroll: function() {
      var $selected = $('.selected', this.$predictionsContainer),
          containerHeight, containerViewTop, containerViewBottom, itemTop, itemBottom;

      if ($selected.length) {
        containerHeight = this.$predictionsContainer.height();
        containerViewTop = this.$predictionsContainer.scrollTop();
        containerViewBottom = containerViewTop + containerHeight;
        itemTop = $selected.position().top + containerViewTop;
        itemBottom = itemTop + $selected.outerHeight();

        if (itemTop < containerViewTop) {
          this.$predictionsContainer.scrollTop(itemTop);
        }

        if (itemBottom > containerViewBottom) {
          this.$predictionsContainer.scrollTop(itemBottom - containerHeight);
        }
      }
    },
    move: function(direction) {
      if (direction === 'down') {
        this.selectedIndex++;
        if (this.selectedIndex > this.predictions.length-1) this.selectedIndex = 0;
      }
      else {
        this.selectedIndex--;
        if (this.selectedIndex < 0) this.selectedIndex = this.predictions.length-1;
      }

      this.updateSelected(this.selectedIndex);
      this.adjustListScroll();
    },
    handleSuggestionChange: function() {
      if (this.query() !== this.lastSearch) {
        this.selectedIndex = -1;
        this.lastSearch = this.query();
        this.getPredictions();
      }
    },
    buildQueryParameters: function(searchQuery) {
      var params = this.resultsType === 'stores' ? this.defaults.locationAPIParams : {};

      params.search = searchQuery;

      return params;
    },
    buildEndpoint: function() {
      if (this.resultsType === 'stores') {
        var business = window.SEARCH_BUSINESS;
        return this.defaults.locationAPI + business + '/';
      }
      else {
        return this.defaults.placesAPI;
      }
    },
    getPredictions: function() {
      var self = this;

      self.globalTimeout = null;

      this.callPredictionsAPI(this.query()).done(function(data, status) {
        if (status === 'success') {
          if (self.resultsType === 'stores') {
            self.predictions = self.processLocationAPIResults(data);
          }
          else {
            self.predictions = self.processPlacesAPIResults(data);
          }

          self.renderResults();
        } else {
          self.removePredictions();
        }
      }).fail(function() {
        // Fail silently.
        self.removePredictions();
      }).always(function() {
        self.$suggestionInput.trigger('stopLookup');
      });
    },
    callPredictionsAPI: function(searchQuery) {
      this.$suggestionInput.trigger('startLookup');

      this.ApiDeferred = $.Deferred();

      var csrftoken = jQuery("[name=csrfmiddlewaretoken]").val();
      $.ajaxSetup({
        beforeSend: function(xhr, settings) {
          xhr.setRequestHeader("X-CSRFToken", csrftoken);
        }
      });

      $.ajax({
        url: this.buildEndpoint(),
        dataType: 'json',
        data: this.buildQueryParameters(searchQuery),
        method: this.resultsType === 'stores' ? 'GET' : 'POST'
      })
      .done(this.ApiDeferred.resolve)
      .fail(this.ApiDeferred.reject);

      return this.ApiDeferred.promise();
    },
    processLocationAPIResults: function(data) {
      var predictions = [],
          strip = /(Heart Of England Co-operative Lateshop - |Co-operative Locales |The Co-operative Food - |The Co-operative Food |Co-operative Food Store |Co-operative Food Store - |Scottish Midland Co-operative Food Store - |Scottish Midland Co-operative Food Store |Lincolnshire Co-op |East Of England Co-op Foodstore - |East Of England Co-op Foodstore|East Of England Co-op Supermarket - |The Co-operative )+/;

      for (var i = 0; i < data.results.length; i++) {
        var result = data.results[i],
            item = {
              label: result.name.replace(strip, ''),
              classes: 'icon icon-location-alt',
              attrs: {
                'data-result-type': 'store',
                'data-url': result.url
              }
            };

        if (result.town.length) {
          item.small_label = result.town;
        }

        predictions.push(item);
      }

      return predictions;
    },
    processPlacesAPIResults: function(data) {
      var predictions = [];

      for (var i = 0; i < data.predictions.length; i++) {
        var result = data.predictions[i],
            item = {
              label: result.structured_formatting.main_text,
              small_label: result.structured_formatting.secondary_text,
              attrs: {
                'data-result-type': 'place',
                'data-place-name': result.structured_formatting.main_text +' '+ result.structured_formatting.secondary_text
              }
            };

        predictions.push(item);
      }

      return predictions;
    },
    highlightQuery: function(str) {
      if (this.query().length === 0) return str;

      var re = new RegExp('(' + this.query() + ')', 'gi');
      return str.replace(re, '<em>$1</em>');
    },
    renderResults: function() {
      var $resultsList = $('<ul></ul>');

      if (this.predictions.length === 0) {
        this.$predictionsContainer.empty().hide();
        return;
      }

      for (var i = 0; i < this.predictions.length; i++) {
        var result = this.predictions[i],
            label = this.highlightQuery(result.label),
            attrs = result.attrs,
            $listItem = $('<li></li>').addClass('autocomplete-item');

        attrs['data-index'] = i;

        if (result.small_label) {
            label += ' <small>' + this.highlightQuery(result.small_label) + '</small>';
        }

        if (result.classes) {
          $listItem.addClass(result.classes);
        }

        $listItem
          .attr(attrs)
          .html(label)
          .appendTo($resultsList);
      }

      this.$predictionsContainer
        .empty()
        .append($resultsList)
        .show();

      this.bindListEvents();
    },
    createAutoCompleteContainer: function() {
      var id = this.$suggestionInput.attr('name') || this.randomId;

      this.$predictionsContainer = $('<div/>').addClass(this.defaults.containerClass + ' autocomplete-' + id)
                                      .attr('id', 'autocomplete-' + id)
                                      .insertAfter(this.$suggestionInput.parent())
                                      .hide();

      this.bindAutoCompleteEvents();
    },
    removePredictions: function() {
      var self = this;

      this.predictions = [];
      this.$predictionsContainer.empty().hide();

      // if no input value
      if (this.$suggestionInput.val() === '') {
        // and deferreds are in progress then resolve on success
        if (this.ApiDeferred) {
          this.ApiDeferred.then(function(){
            self.$predictionsContainer.empty().hide();
          });
        }
      }
    },
    doRedirect: function(href) {
      window.location = href;
    },
    useSelected: function() {
      if (this.selectedIndex === -1) return;

      var $item = $('[data-index=' + this.selectedIndex + ']', this.$predictionsContainer);

      if ($item.data('url')) {
        this.doRedirect($item.data('url'));
      }
      else if($item.data('placeName')) {
        this.$suggestionInput.val($item.data('placeName'));
        clearTimeout(this.globalTimeout);
        this.removePredictions();
        window.locationSearch.$form.submit();
      }
    }
  };
})();
